const tabsData = [
    {
        id: 1,
        title: "HTML",
        content: "HTML (HyperText Markup Language) is the most basic building block of the Web. It defines the meaning and structure of web content. 'Hypertext' refers to links that connect web pages to one another, either within a single website or between websites.",
    },
    {
        id: 2,
        title: "CSS",
        content: "Cascading Style Sheets (CSS) is a stylesheet language used to describe the presentation (style) of a document written in HTML or XML. CSS describes how elements should be rendered on screen, on paper, in speech, or on other media.",
    },
    {
        id: 3,
        title: "JavaScript",
        content: "JavaScript (JS) is a lightweight, interpreted, or just-in-time compiled programming language. While it is most well-known as the scripting language for Web pages, many non-browser environments also use it, such as Node.js, Apache CouchDB.",
    },
];

export default tabsData;